import React from "react";

import { PickerField } from "@/components/selection/PickerField";
import { RegistrationActions } from "@/layouts/RegistrationFlowLayout";

type Option = { value: string; label: string };
type JobStepProps = {
  jobCategory: string;
  jobIndustry: string;
  jobContinuousPeriod: string;
  onChangeJobCategory: (value: string) => void;
  onChangeJobIndustry: (value: string) => void;
  onChangeJobContinuousPeriod: (value: string) => void;
  occupationOptions: Option[];
  jobIndustryOptions: Option[];
  periodRangeOptions: Option[];
  needsJobIndustry: boolean;
  errors: { job?: string; industry?: string; period?: string };
  onBlur: (name: string) => void;
  onNext: () => void;
  onBack: () => void;
};
const JobStep: React.FC<JobStepProps> = ({
  jobCategory,
  jobIndustry,
  jobContinuousPeriod,
  onChangeJobCategory,
  onChangeJobIndustry,
  onChangeJobContinuousPeriod,
  occupationOptions,
  jobIndustryOptions,
  periodRangeOptions,
  needsJobIndustry,
  errors,
  onBlur,
  onNext,
  onBack,
}) => (
  <>
    <PickerField
      label="ご職業"
      value={jobCategory}
      onChange={(value) => onChangeJobCategory(String(value))}
      options={occupationOptions}
      error={errors.job}
      onBlur={() => onBlur("job")}
    />
    {needsJobIndustry && (
      <PickerField
        label="業種"
        value={jobIndustry}
        onChange={(value) => onChangeJobIndustry(String(value))}
        options={jobIndustryOptions}
        searchable
        error={errors.industry}
        onBlur={() => onBlur("industry")}
      />
    )}
    <PickerField
      label="勤続年数"
      value={jobContinuousPeriod}
      onChange={(value) => onChangeJobContinuousPeriod(String(value))}
      options={periodRangeOptions}
      error={errors.period}
      onBlur={() => onBlur("period")}
    />
    <RegistrationActions onNext={onNext} onBack={onBack} />
  </>
);
export default JobStep;
